export const ACTION_WINDOW_DAYS = 14;
export const URGENT_WINDOW_DAYS = 3;

export type ActionAlertUrgency = "overdue" | "urgent" | "soon";

export function daysUntilDue(value: string | Date | null, now = Date.now()): number | null {
  if (!value) return null;
  const dueMs = typeof value === "string" ? new Date(value).getTime() : value.getTime();
  if (Number.isNaN(dueMs)) return null;
  // Count whole CALENDAR days between today and the due date using UTC day-numbers. This is
  // timezone-independent and stable across the day: a deadline on the next calendar day is
  // always 1 ("Due tomorrow"), never 2 just because the time-of-day differs. The previous
  // Math.ceil on the raw millisecond delta over-counted partial days, which made
  // deadlineDisplay's relative-date test flaky (it failed in CI's UTC runner near midnight).
  const dayNumber = (ms: number): number => Math.floor(ms / 86_400_000);
  return dayNumber(dueMs) - dayNumber(now);
}

export function urgencyForDays(days: number): ActionAlertUrgency {
  if (days < 0) return "overdue";
  if (days <= URGENT_WINDOW_DAYS) return "urgent";
  return "soon";
}

export function urgencyForDueDate(value: string | Date | null, now = Date.now()): ActionAlertUrgency | null {
  const days = daysUntilDue(value, now);
  if (days === null) return null;
  return urgencyForDays(days);
}

export function isWithinActionWindow(value: string | Date | null, now = Date.now()): boolean {
  const days = daysUntilDue(value, now);
  if (days === null) return false;
  return days <= ACTION_WINDOW_DAYS;
}
